<template>
    <div>
        <v-server-table name="nonCompliantTable" ref="nonCompliantTable" url="/reports/non-compliant-items" :columns="columns" :options="options">

            <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                <div class="clearfix d-md-none d-block"></div>

                <div v-if="allowFilterSaving" class="float-left mr-1">
                    <user-filters ref="nonCompliantSavedFilters" assetType="NonCompliantItems" :filterKey="filterKey" @saving="setUserFilterData" @show="setUserFilterData"></user-filters>
                </div>

                <div class="float-md-left">
                    <div class="float-left">
                        <table-filters-2 ref="nonCompliantTableFilters" v-bind:filters="filters"
                        filterUrl="/reports/filters/inspections"
                        :filterKey="filterKey"
                        :emptyFilters="filterDefs"
                        @filtersChanged="refreshTableData"
                        @filtersCleared="filtersCleared">
                            <template slot-scope="slotProps">
                                <div class="d-inline-block" v-if="slotProps.filterData.sections && slotProps.filterData.sections.length > 0">
                                    <multi-select v-model="slotProps.filters['NonCompliant_SectionId']" :btnLabel="(values) => ('Sections ('+values.length+')')" :selectOptions="slotProps.filterData.sections" :options="{multi: true}"></multi-select>
                                </div>
                                <div class="d-inline-block" v-if="slotProps.filterData.elements && slotProps.filterData.elements.length > 0">
                                    <multi-select v-model="slotProps.filters['NonCompliant_ElementId']" :btnLabel="(values) => ('Elements ('+values.length+')')" :selectOptions="slotProps.filterData.elements" :options="{multi: true, groups: true}"></multi-select>
                                </div>
                                <div class="d-inline-block">
                                    <multi-select v-model="slotProps.filters['jobsite.JobsiteId']" :btnLabel="(values) => ('Jobsites ('+values.length+')')" :selectOptions="slotProps.filterData.jobsites" :options="{multi: true}" :search="true"></multi-select>
                                </div>
                                <div class="d-inline-block">
                                    <multi-select v-model="slotProps.filters['jobsite.DivisionId']" :btnLabel="(values) => ('Divisions ('+values.length+')')" :selectOptions="slotProps.filterData.divisions" :options="{multi: true}"></multi-select>
                                </div>
                                <div class="d-inline-block">
                                    <multi-select v-model="slotProps.filters['corrective_actions.status_id']" :btnLabel="(values) => ('Statuses ('+values.length+')')" :selectOptions="slotProps.filterData.statuses" :options="{multi: true}"></multi-select>
                                </div>
                                <div class="d-inline-block">
                                    <date-range-selector buttonTitle="Item Date" v-model="slotProps.filters['NonCompliant_ItemDate']" />
                                </div>
                                <div class="d-inline-block">
                                    <multi-select v-model="slotProps.filters['non_compliant_insp_form_id']" :btnLabel="(values) => ('Inspection Forms ('+values.length+')')" :selectOptions="slotProps.filterData.formOptions" :options="{multi: true}"></multi-select>
                                </div>
                                <div class="mt-2">
                                    <div class="d-inline-block">
                                        <b-form-select v-model="slotProps.filters['corrective_actions.asset_type']" :options="slotProps.filterData.assetTypes" size="sm"></b-form-select>
                                    </div>
                                    <div class="d-inline-block" style="width: 250px;">
                                        <user-select :forFilters="true" :selectedValues="slotProps.filters['corrective_actions.creator_id']"></user-select>
                                    </div>
                                </div>
                            </template>
                        </table-filters-2>
                    </div>

                    <button type="button" class="btn btn-outline-success ml-2" v-on:click="exportTable()" :disabled="exportingTable">
                        <template v-if="!exportingTable"><i class="fa fa-file-excel-o"></i> Export</template>
                        <template v-else><i class="fa fa-circle-o-notch fa-spin"></i> Exporting</template>
                    </button>

                    <div class="clearfix d-md-none d-block"></div>
                </div>

                <div class="clearfix d-md-none d-block"></div>
            </div>

            <template slot="corrective_action_id" slot-scope="props">
                <router-link :to="`/corrective-actions/view/${props.row.corrective_action_id}`" title="View Corrective Action" class="btn btn-xs btn-secondary">
                    View CA
                </router-link>
            </template>

            <template slot="Id" slot-scope="props">
                <router-link :to="`/inspections/result/${props.row.Id}`" title="View Inspection Result" class="btn btn-xs btn-light ml-1" v-if="props.row.asset_type == 'InspectionResult'">
                    View Result
                </router-link>
                <router-link :to="`/observations/view/${props.row.Id}`" title="View Observation" class="btn btn-xs btn-light ml-1" v-if="props.row.asset_type == 'Observation'">
                    View Obsv.
                </router-link>
            </template>

            <router-link slot="JobsiteName" slot-scope="props" :to="`/jobsites/view/${props.row.JobsiteId}`" title="View Jobsite">
                {{ props.row.JobsiteNumber }} - {{ props.row.JobsiteName }}
            </router-link>

            <template slot="ElementOrder" slot-scope="props">
                {{props.row.SectionOrder}}.{{props.row.ElementOrder}}
            </template>

            <template slot="status_name" slot-scope="props">
                <label :class="`badge badge-${props.row.status_color}`">{{ props.row.status_name }}</label>
            </template>

            <template slot="ItemDate" slot-scope="props">
                {{ props.row.ItemDate | moment("MM/DD/YYYY") }}
            </template>

        </v-server-table>
    </div>
</template>

<script>
    import filterExtractor from '@/helpers/TableFilterExtractor';

    export default {
        props: {
            allowFilterSaving: {
                type: Boolean,
                default: false,
            },
        },

        data: function() {
            return {
                loading: true,
                columns: ['corrective_action_id', 'Id', 'JobsiteName', 'ElementOrder', 'SectionName', 'ElementText', 'status_name', 'detail', 'completed_detail', 'creator_name', 'assignee_name', 'ItemDate'],
                options: {
                    headings: {
                        corrective_action_id: 'View',
                        JobsiteName: 'Jobsite',
                        ElementOrder: 'Item',
                        SectionName: 'Section',
                        ElementText: 'Element',
                        status_name: 'Status',
                        detail: 'Detail',
                        completed_detail: 'Completed Detail',
                        creator_name: 'Created By',
                        assignee_name: 'Assigned To',
                        ItemDate: 'Date'
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('noncompliantListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Set the filters
                        data.filters = filterExtractor.extractFilters(this.filters);

                        //Send it
                        return data;
                    },
                    uniqueKey: 'corrective_action_id',
                    orderBy: {
                        ascending: false,
                        column: 'ItemDate',
                    }
                },
                jobsites: [],
                isLoading: false,
                exportingTable: false,

                filterKey: 'nonCompliantFilters',

                filterDefs: {
                    'NonCompliant_SectionId': [],
                    'NonCompliant_ElementId': [],
                    'NonCompliant_ItemDate': '',
                    'jobsite.DivisionId': [],
                    'jobsite.JobsiteId': [],
                    'corrective_actions.asset_type': "",
                    'corrective_actions.creator_id': {},
                    'corrective_actions.status_id': [],
                    'non_compliant_insp_form_id': [],
                },
            }
        },

        watch: {

            appliedFilter(newVal, oldVal){
                //Call the helper
                this.checkForAppliedFilter();
            },
        },

        computed: {
            filters(){
                //Check State
                if(this.$store.state.tableFilters.filters[this.filterKey])
                {
                    //Send it
                    return this.$store.state.tableFilters.filters[this.filterKey];
                }

                //Return Definition
                return JSON.parse(JSON.stringify(this.filterDefs));
            },

            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },
        },

        methods: {

            refreshTableData(filters) {
                //Set the data
                this.$refs.nonCompliantTable.setPage(1); //This will call getData()
                //this.$refs.nonCompliantTable.getData();
            },

            filtersCleared(){
                //Reset
                this.refreshTableData();

                //Reset the Columns
                this.$refs.nonCompliantTableFilters.resetColVis(this.$refs.nonCompliantTable);
            },

            setUserFilterData(){
                //Call the Helper
                this.$refs.nonCompliantSavedFilters.setFilterParams(this.$refs.nonCompliantTable);
            },

            checkForAppliedFilter(){
                //Check if
                if(!this.allowFilterSaving || !this.appliedFilter)
                {
                    return;
                }

                //Call the helper
                this.$refs.nonCompliantTableFilters.setColVis(this.$refs.nonCompliantTable);
            },

            exportTable(){
                //Loading indicator
                this.exportingTable = true;

                //Build the Filters
                var filters = filterExtractor.extractFilters(this.filters);

                //Build the payload
                var payload = {
                    filters: filters,
                    query: (this.$refs.nonCompliantTable.getRequestParams()).query,
                    orderBy: this.$refs.nonCompliantTable.options.orderBy.column,
                    ascending: this.$refs.nonCompliantTable.options.orderBy.ascending,
                    table: 'nonCompliantTable',
                    columns: this.$refs.nonCompliantTable.columns,
                };

                //Send it
                this.$http.get('/reports/non-compliant-items?export=true', payload)
                    .then(response => {
                        //Open the new window
                        window.open(response.data);
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.error(err.response.data, 'Failed to Export Non-Compliant Items');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },
        },

        mounted() {
            //Check for a saved filter
            this.checkForAppliedFilter();
        }
    }
</script>
